import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import type { ListPageConfig, ListRow } from '@/shared/ui/list/types';
import { fetchStatServiceList } from './api';
import { dateRangeFilters, franchiseFilter, monthFilter, placeFilters } from './filters';

interface ServiceStatRow extends ListRow {
  service_id: number;
  service_name?: string;
  city_name?: string;
  avg_rating?: number | string;
  bids?: number | string;
  bids_answered?: number | string;
  bids_chosen?: number | string;
  bids_total_done?: number | string;
  bids_rejected?: number | string;
  bids_closed?: number | string;
  bids_total_cost?: number | string;
  all_answered_ratio?: number | string;
  answered_chosen_ratio?: number | string;
  avg_answer_time?: number | string;
}

const config: ListPageConfig<ServiceStatRow> = {
  queryKey: 'stat-list',
  title: 'Статистика',
  boxTitle: 'Статистика по сервисам',
  errorText: 'Ошибка загрузки статистики по сервисам',
  fetchList: fetchStatServiceList,
  rows: ['statistic'],
  searchKeys: [
    { value: 'service_id', label: 'Поиск по id сервиса' },
    { value: 'name', label: 'Поиск по имени сервиса' },
  ],
  filters: [
    ...dateRangeFilters(true),
    monthFilter,
    ...placeFilters(true),
    franchiseFilter,
  ],
  columns: [
    { header: 'ID', render: (row) => row.service_id },
    { header: 'Название', render: (row) => row.service_name },
    { header: 'Город', render: (row) => row.city_name },
    { header: 'Средний рейтинг', render: (row) => row.avg_rating },
    { header: 'Кол-во заявок, назначенных автосервису', render: (row) => row.bids },
    {
      header: 'Кол-во заявок, на которые откликнулся автосервис',
      render: (row) => row.bids_answered,
    },
    { header: 'Количество клиентов, выбравших данный сервис', render: (row) => row.bids_chosen },
    { header: 'Количество выполненных заявок', render: (row) => row.bids_total_done },
    { header: 'Количество отмененных выборов', render: (row) => row.bids_rejected },
    { header: 'Количество закрытых заявок', render: (row) => row.bids_closed },
    { header: 'Сумма, заработанная автосервисом', render: (row) => row.bids_total_cost },
    { header: 'Активность', render: (row) => row.all_answered_ratio },
    { header: 'Эффективность', render: (row) => row.answered_chosen_ratio },
    { header: 'Среднее время ответа (в часах)', render: (row) => row.avg_answer_time },
  ],
};

export const StatListPage = () => <GenericListPage config={config} />;
